import { CustomerAPI } from 'api'
import { checkStatus, pluckData } from 'utils/api'

export const verifyWidgetSnippet = (url, strict = true) => {
  return CustomerAPI.get('/snippets/verify', { params: { url, strict } })
    .then(checkStatus())
    .then(pluckData())
}
